<template lang="html">
   <div class="tran_by_date">
      <div class="row justify-content-center">
         <div class="col-12 col-md-7">
            <Form 
               classBinding="row" 
               :ref="Transaction.forms.queryByRange.name" 
               :forms="Transaction.forms.queryByRange.forms" 
               :form_data="Transaction.forms.queryByRange.data"
            />
         </div>
         <div class="col-12 col-md-5 col-lg-3 col-xl-4">
            <div class="btn btn-primary btn-padded" :disabled="loading" @click="queryTransactions({ref: $refs[Transaction.forms.queryByRange.name]})">
               Query
               <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
            </div>
         </div>
      </div>

      <Table 
         :icon="Transaction.tables.transactions.icon" 
         :table_fields="Transaction.tables.transactions.table_fields" 
         :table_data="transactions" 
         :title="Transaction.tables.transactions.title" 
         :search_fields="Transaction.tables.transactions.search_fields"
         :row_data="Transaction.tables.transactions.row_data"
      />

      <div class="row justify-content-end" v-if="transactions.length > 0">
         <div class="col-12 col-md-4 col-lg-3">
            <div class="btn btn-long btn-primary mt-3" @click="downloadExcel()">Download Report</div>
         </div>
      </div>
   </div>
</template>

<script>
import transaction from "../rsc/stores/transactions/transaction.store";
const XLSX = require('xlsx')

export default {
   beforeDestroy () {
      this.$store.unregisterModule('transaction')
   },
   created(){
      EventBus.$emit('loader:show',true)
      utils.registerModule('transaction',transaction,this.$store)

      setTimeout(() => {
         EventBus.$emit('actions:register',{
            title: '',
            actions: []
         })
      },200);
   },
   components:{
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
      Table: () => import("@/libs/clarks/components/table/table"),
   },
   computed: {
      ...mapGetters([
         'Transaction',
         'transactions',
         'show',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'submitForm',
         'queryTransactions',
      ]),
      downloadExcel(){
         try{
            let trans = []

            for (let i = 0; i < this.transactions.length; i++) {
               const tran = this.transactions[i];
               trans.push({
                  'Internal Ref': tran._id,
                  'Transaction Reference': tran.transaction_id,
                  'Amount': tran.amount,
                  'Verification Date': moment(tran.verified_at).format('DD-MM-YYYY'),
                  'Verification Time': moment(tran.verified_at).format('HH:mm'),
                  'Transaction Status': tran.status,
               })
            }
            var workSheet = XLSX.utils.json_to_sheet(trans);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, workSheet, 'transactions');
            XLSX.writeFile(wb, 'transactions.xlsx')
         }catch(err){
            console.log(err)
         }
      }
   },
   async mounted(){
      utils.registerModule('transaction',transaction,this.$store)
      EventBus.$emit('loader:show', false)
   }
}
</script>

<style lang="scss">
   .tran_by_date{
      .form-label{
         width: 100%;
      }
   }
</style>